import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';
import ConsultaVirtual from '../../Images/Consulta_virtual.jpeg';
import ConsultaPresencial from '../../Images/Consulta_presencial.jpeg';
import ServicesModal from '../ServicesModal/ServicesModal';
import './Servicios.css';

const Servicios = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const consultationTypes = [
    {
      title: "Consultas Virtuales",
      image: ConsultaVirtual,
      description: "Atención nutricional profesional desde la comodidad de tu hogar",
      features: [
        "Evaluación nutricional online",
        "Evaluaciones virtuales cada 2 a 3 semanas",
        "Plan nutricional adaptado a tu objetivo",
        "Revisión de exámenes clínicos (glucosa, colesterol, Hemoglobina, si cuentas con ellos)",
        "Monitoreo y seguimiento continuo por WhatsApp",
        "Atención por videollamada (Zoom o Google Meet)"
      ]
    },
    {
      title: "Consultas Presenciales",
      image: ConsultaPresencial,
      description: "Atención personalizada cara a cara en consultorio",
      features: [
        "Evaluación nutricional personalizada",
        "Evaluaciones presenciales cada 2 a 3 semanas",
        "Plan nutricional adaptado a tu objetivo",
        "Mediciones antropométricas y bioimpedancia",
        "Análisis clínico: Glucosa, colesterol y hemoglobina",
        "Citas remotas y consultoría continua"
      ]
    }
  ];

  return (
    <>
      <div className="servicios-content">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="servicios-header"
        >
          <h2 className="servicios-title">
            Elige tu modalidad de <span className="highlight">consulta</span>
          </h2>
          <p className="servicios-description">
            Escoge la opción que mejor se adapte a tu estilo de vida. En ambas modalidades
            podrás acceder a todos nuestros planes nutricionales personalizados.
          </p>
        </motion.div>

        <div className="consultation-types-grid">
          {consultationTypes.map((type, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 * index }}
              className="consultation-card"
            >
              <div className="consultation-image">
                <img src={type.image} alt={type.title} />
              </div>

              <div className="consultation-content">
                <h2 className="consultation-title">{type.title}</h2>
                <p className="consultation-description">{type.description}</p>

                <div className="features-section">
                  <h3 className="section-subtitle">¿Qué incluye?</h3>
                  <div className="features-list">
                    {type.features.map((feature, idx) => (
                      <div key={idx} className="feature-item">
                        <div className="checkmark">✓</div>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="consultation-button"
                  onClick={() => setIsModalOpen(true)}
                >
                  <Calendar className="button-icon" />
                  Agendar Cita
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="plans-cta-section"
        >
          <div className="plans-cta-content">
            <h2 className="plans-cta-title">
              Descubre nuestros <span className="highlight">Planes Nutricionales</span>
            </h2>
            <p className="plans-cta-description">
              Después de tu consulta, podrás elegir entre diversos planes especializados
              según tus objetivos: pérdida de peso, ganancia muscular, salud digestiva,
              rendimiento deportivo y más.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="plans-cta-button"
              onClick={(e) => scrollToSection(e, 'planes')}
            >
              Explorar Planes Nutricionales
              <ArrowRight className="button-icon" />
            </motion.button>
          </div>
        </motion.div>
      </div>

      <ServicesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Servicios;